import { render, staticRenderFns } from "./UserProfileCard.vue?vue&type=template&id=0806b32b&scoped=true"
import script from "./UserProfileCard.vue?vue&type=script&lang=js"
export * from "./UserProfileCard.vue?vue&type=script&lang=js"
import style0 from "./UserProfileCard.vue?vue&type=style&index=0&id=0806b32b&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../lianqiao-im/im-web/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0806b32b",
  null
  
)

export default component.exports